import type { VoMicroServices } from './typings';
import { API_SERVICE_AUTH, API_SERVICE_SYS } from '@inn/const';
import { xhr } from '@/utils';

/**
 * 系统服务相关的 api 资源模块
 *
 * @module apis/service
 */

/**
 * 获取后端微服务网关资源列表
 */
export async function getMicroServices() {
  const { data } = await xhr.get<VoXObject<VoMicroServices[]>>(`${API_SERVICE_SYS}/service/list`);
  return data.data;
}

/**
 * 获取加密公钥
 */
export async function reqRsaPublicKey() {
  const { data } = await xhr.get<string>(`${API_SERVICE_AUTH}/rsa_public_key`, {
    withoutToken: true,
  });
  return data;
}

export * from './typings';
